import {translate} from '@/services/i18n'
import {Interval} from '@/modules/typedef'

export const cyclePriceOptions = [
  {label: translate('monthly'), value: Interval.MONTH},
  {label: translate('yearly'), value: Interval.YEAR},
]
